<template>
    <div class="d-flex justify-content-start py-3">
        <v-btn
            v-if="
                (currentForm.id && can('api.v1.laboratories.update')) ||
                (!currentForm.id &&
                    can('api.v1.laboratories.store') &&
                    currentForm.id &&
                    can('api.v1.collection-centres.update')) ||
                (!currentForm.id && can('api.v1.collection-centres.store'))
            "
            rounded
            text
            color="primary"
            @click="cancelAction"
        >
            {{ t('blood-providers::button.cancel') }}
        </v-btn>
        <v-btn
            v-if="
                (currentForm.id && can('api.v1.laboratories.update')) ||
                (!currentForm.id &&
                    can('api.v1.laboratories.store') &&
                    currentForm.id &&
                    can('api.v1.collection-centres.update')) ||
                (!currentForm.id && can('api.v1.collection-centres.store'))
            "
            rounded
            color="primary"
            class="ml-4"
            :loading="labCCFormLoading"
            @click="saveLabOrCC()"
        >
            {{ isAdmin ? t('blood-providers::button.submit') : t('blood-providers::button.send_save_request') }}
        </v-btn>
    </div>
</template>

<script>
export default {
    data() {
        return {
            labCCFormLoading: false,
        };
    },
    computed: {
        currentForm() {
            return this.$store.state.laboratories.currentForm;
        },
        currentFormState() {
            const stateValues = { 'collection-centres': 'collection_centre', laboratories: 'laboratory' };

            return stateValues[this.currentForm];
        },
        currentFormData() {
            return this.$store.state.laboratories[this.currentFormState];
        },
        isAdmin() {
            return User.group === 'admins';
        },
    },
    methods: {
        saveLabOrCC() {
            this.labCCFormLoading = true;
            this.$store.dispatch('laboratories/resetErrorMessages');
            let updateProperty = {};
            updateProperty[this.currentFormState] = this.currentFormData.id;
            axios({
                method: this.currentFormData.id ? 'put' : 'post',
                url: this.currentFormData.id
                    ? route(`api.v1.${this.currentForm}.update`, updateProperty)
                    : route(`api.v1.${this.currentForm}.store`),
                data: this.currentFormData,
            })
                .then(() => {
                    _.delay(() => {
                        this.$root.goTo(route('providers.index'));
                    }, 1000);
                    if (!this.currentFormData.id) {
                        if (this.isAdmin) {
                            return this.$root.notify(
                                'info',
                                t('blood-providers::notification.success'),
                                t('blood-providers::notification.blood_providers.created')
                            );
                        } else {
                            return this.$root.notify(
                                'info',
                                t('blood-providers::notification.success'),
                                t('blood-providers::notification.blood_providers.send_approval')
                            );
                        }
                    }
                    if (this.currentFormData.id) {
                        if (this.isAdmin) {
                            return this.$root.notify(
                                'info',
                                t('blood-providers::notification.success'),
                                t('blood-providers::notification.blood_providers.update')
                            );
                        } else {
                            return this.$root.notify(
                                'info',
                                t('blood-providers::notification.success'),
                                t('blood-providers::notification.blood_providers.send_approval')
                            );
                        }
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('laboratories/setErrorMessages', error.response.data.errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => _.delay(() => (this.labCCFormLoading = false), 1400));
        },
        cancelAction() {
            this.$root.goTo(route('providers.index'));
        },
    },
};
</script>

<style></style>
